/* eslint-disable no-extend-native */
import { maskCpf } from "../utils/cpf";
import { maskCpfCnpj } from "../utils/documento";

String.prototype.maskCPF = function (): string {
  return maskCpf(this.toString());
};

String.prototype.formatDate = function (): string {
  if (!this) return "";
  const newDate = new Date(this);
  return newDate.toLocaleDateString("pt-BR");
};

String.prototype.isEquals = function (value: string): boolean {
  if (typeof value !== "string") return false;
  return this === value;
};

String.prototype.maskCpfCnpj = function (): string {
  return maskCpfCnpj(this.toString());
};

String.prototype.maskCep = function (): string {
  return this.replace(/\D/g, "").replace(/(\d{5})(\d{3})/, "$1-$2");
};

export {};
